import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente único do TanStack Query.
 *
 * Defaults conservadores para um CRM com Realtime:
 * - staleTime 60s evita refetch imediato ao remontar componentes (o grande
 *   problema atual: ~10 queries "frias" refeitas em 30+ lugares).
 * - refetchOnWindowFocus desligado porque a revalidação virá do Realtime
 *   (ponte postgres_changes -> queryClient.invalidateQueries) na Fase 1.
 *
 * Queries de configuração que quase nunca mudam (commission_rates,
 * workspace_origens, agenda config) devem sobrescrever com staleTime alto.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
